import { Injectable } from '@angular/core';
import { SecureApi } from '../../../core/secure.api';

@Injectable()

export class InteractiveMapService {
    constructor(public secureApi: SecureApi) { }

    /**
     * Get all available interactive-map, which are used in popup choose diagnosis.
     */
    getDiagnosesList() {
        return this.secureApi.get('interactiveMap/get-list')['list'];
    }

    /**
     * Get diagnosis data of patient.
     * @param id Patient_id
     */
    read(id: number) {
        return this.secureApi.get('interactive-map/read/' + id);
    }

    getData(id: number) {
        return this.secureApi.get('patient-questionnaire/questionnaire-data/' + id);
    }

    updateRating(data) {
        return this.secureApi.post(`patient-questionnaire/diagnosis-interview/symptoms/${data.patient_questionnaire_id}/${data.domain_id}/${data.isAcute}`, data, false);
    }

    updatePrimary(data) {
        return this.secureApi.post(`patient-questionnaire/diagnosis-interview/feeling-primary/${data.patient_questionnaire_id}`, data, false);
    }

    updateDomain(data){
        return this.secureApi.post(`patient-questionnaire/diagnosis-interview/domain-status/${data.patientQuestionnaireId}/${data.domainId}/${data.excludeSymtoms || "" }`, {params: data.params}, false);
    }

    updateSymptomDone(data){
        return this.secureApi.post(`patient-questionnaire/diagnosis-interview/symptom-status/${data.patientQuestionnaireId}/${data.domainId}`, data, false);
    }

    setDomainHistory(data) {
        return this.secureApi.post(`patient-questionnaire/diagnosis-interview/syndrome-history/${data.patientQuestionnaireId}/${data.domainId}`, data.params, false);
    }
}
